import { useQuery } from "react-query";
import { getAggregatedProductInfo } from "../../../api/left-rail-menu";

export const useAggregatedProductInfo = (shipmentProductKey) => {
    return useQuery({
        queryKey: ["leftRailMenu", shipmentProductKey],
        queryFn: () => getAggregatedProductInfo(shipmentProductKey),
        staleTime: 60 * 5,
    });
};
